import React from 'react'
import logo from './logos/bg-Logo-Blue.png'

function LogoWithCaptionBlue({
  className
}) {
  return (
    <div className={className}>
      <img src={logo} alt="Xivix Logo"/>
    </div>
    )
  }

export default LogoWithCaptionBlue
